"use strict";
/**
 * Track active cancel handlers in self-describing map
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.track = track;
exports.getActiveCancellers = getActiveCancellers;
// Move ActiveCancellers into a separate module.
const activeCancellers = new Map();
/**
 * Register given canceller with given description, and return a wrapper
 * that invokes the canceller and also unregisters it.
 *
 * @returns wrapper canceller
 */
function track(desc, canceller) {
    activeCancellers.set(canceller, desc);
    return () => {
        try {
            canceller();
        }
        finally {
            activeCancellers.delete(canceller);
        }
    };
}
/**
 * Get the current outstanding cancellers.
 */
function getActiveCancellers() {
    return activeCancellers;
}
//# sourceMappingURL=CancelTracker.js.map